/**
 * Stable empty collections for hook defaults (avoids new [] each render).
 */
export const EMPTY_WORK_QUEUE_LIST = Object.freeze([]);

/**
 * Notify parent inbox badges only when counts change (prevents setState loops).
 *
 * @param {Function|null} onStatsChange - Parent callback.
 * @param {{ total: number, high: number }} stats - Current queue stats.
 * @param {{ current: { total: number, high: number } }} holder - Mutable ref object.
 */
export const notifyWorkQueueStats = (onStatsChange, stats, holder) => {
    if (!onStatsChange || !holder?.current) {
        return;
    }
    const { total, high } = stats;
    if (holder.current.total === total && holder.current.high === high) {
        return;
    }
    holder.current = { total, high };
    onStatsChange({ total, high });
};
